import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "list-group-item d-flex justify-content-between align-items-center" }
const _hoisted_2 = { class: "d-flex align-items-start w-100 flex-column flex-md-row align-items-md-center" }
const _hoisted_3 = { class: "w-25 w-md-25 ms-2" }
const _hoisted_4 = { class: "m-0" }
const _hoisted_5 = { class: "ms-2 w-25" }
const _hoisted_6 = { class: "badge bg-success me-2" }
const _hoisted_7 = { class: "ms-2" }
const _hoisted_8 = ["data-date"]
const _hoisted_9 = ["data-target", "aria-controls"]
const _hoisted_10 = ["data-bs-target"]
const _hoisted_11 = ["id"]
const _hoisted_12 = {
  class: "card card-body p-0 rounded-0 border-bottom-0 border-top-0",
  style: {"background-color":"rgba(0, 0, 0, 0.05)"}
}
const _hoisted_13 = { class: "d-flex align-items-start w-100 flex-column flex-md-row align-items-md-center" }
const _hoisted_14 = { class: "ms-0 me-2" }
const _hoisted_15 = { class: "m-0 text-success" }
const _hoisted_16 = { class: "w-25 w-md-25 ms-2" }
const _hoisted_17 = { class: "m-0" }
const _hoisted_18 = { class: "m-0" }
const _hoisted_19 = ["onClick", "data-bs-target"]
const _hoisted_20 = ["id"]
const _hoisted_21 = { class: "modal-dialog modal-lg" }
const _hoisted_22 = { class: "modal-content" }
const _hoisted_23 = {
  class: "modal-body text-center",
  style: {"background":"linear-gradient(\n              to top right,\n              #344675,\n              #263148,\n              #263148,\n              #344675,\n              #e14eca\n            )"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ticket_template = _resolveComponent("ticket-template")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("li", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, [
            _createElementVNode("i", {
              class: _normalizeClass(["fas fa-check-circle text-success me-2", 
              _ctx.ticket.tickets.length == 1
                ? _ctx.ticket.tickets[0].untransferable
                  ? ''
                  : 'opacity-0'
                : 'opacity-0'
            ])
            }, null, 2),
            _createElementVNode("strong", null, _toDisplayString(_ctx.ticket.name), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_ctx.ticket.count), (types) => {
            return (_openBlock(), _createElementBlock("p", {
              class: "m-0",
              key: types[0]
            }, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(types[1]), 1),
              _createElementVNode("strong", null, _toDisplayString(types[0]), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", {
            class: "m-0 text-muted",
            "data-date": _ctx.ticket.last_transfered
          }, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.date(_ctx.ticket.last_transfered)[0]), 1),
            _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("small", null, _toDisplayString(_ctx.date(_ctx.ticket.last_transfered)[1]), 1)
          ], 8, _hoisted_8)
        ])
      ]),
      (_ctx.ticket.tickets.length > 1)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-outline-secondary ms-3",
            "data-toggle": "collapse",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleShowCollapse && _ctx.handleShowCollapse(...args))),
            "data-target": `#collapseExample-${_ctx.ticketModalId}`,
            role: "button",
            "aria-expanded": "false",
            "aria-controls": `collapseExample-${_ctx.ticketModalId}`
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(["fas mx-1", _ctx.showCollapse ? 'fa-caret-up' : 'fa-caret-down'])
            }, null, 2)
          ], 8, _hoisted_9))
        : _createCommentVNode("", true),
      (_ctx.ticket.tickets.length == 1)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn btn-outline-secondary ms-auto",
            onClick: _cache[1] || (_cache[1] = () => _ctx.setViewTicket(_ctx.ticket.tickets[0])),
            "data-bs-toggle": "modal",
            "data-bs-target": `#ticketModalView-${_ctx.ticketModalId}`
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "fas fa-ticket-alt" }, null, -1)
          ]))], 8, _hoisted_10))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["collapse", _ctx.showCollapse ? 'show' : '']),
      id: `collapseExample-${_ctx.ticketModalId}`
    }, [
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ticket.tickets, (t) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "border-bottom d-flex px-5 py-3",
            key: t.id
          }, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("p", _hoisted_15, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["fas fa-check-circle", t.untransferable ? '' : 'opacity-0'])
                  }, null, 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_17, [
                    _createElementVNode("strong", null, _toDisplayString(t.option.name), 1),
                    _createElementVNode("small", null, "(" + _toDisplayString(t._id) + ")", 1)
                  ]),
                  _createElementVNode("p", _hoisted_18, [
                    _createElementVNode("small", null, [
                      _cache[4] || (_cache[4] = _createElementVNode("strong", null, "Asignado el:", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.date(t.transfered_at)[0]) + " " + _toDisplayString(_ctx.date(t.transfered_at)[1]), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("button", {
              class: "btn btn-outline-secondary ms-auto",
              onClick: () => _ctx.setViewTicket(t),
              "data-bs-toggle": "modal",
              "data-bs-target": `#ticketModalView-${_ctx.ticketModalId}`
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("i", { class: "fas fa-ticket-alt" }, null, -1)
            ]))], 8, _hoisted_19)
          ]))
        }), 128))
      ])
    ], 10, _hoisted_11),
    _createElementVNode("div", {
      class: "modal fade",
      id: `ticketModalView-${_ctx.ticketModalId}`,
      tabindex: "-1",
      "aria-labelledby": "ticketModalViewLabel",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", {
              class: "modal-title fs-5",
              id: "ticketModalViewLabel"
            }, "Información del ticket"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_23, [
            (_ctx.viewTicket)
              ? (_openBlock(), _createBlock(_component_ticket_template, {
                  key: 0,
                  ticket: _ctx.viewTicket
                }, null, 8, ["ticket"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 8, _hoisted_20)
  ], 64))
}